import { NgModule } from '@angular/core';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { XSi18nService } from '@nx-fe/services';
import { PipesModule, XsI18nPipe } from '@nx-fe/pipes';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    LoginPageComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    BrowserModule,
    PipesModule,
    FormsModule,
    RouterModule
  ],
  providers: [
    XSi18nService,
    XsI18nPipe
  ],
  bootstrap: []
})
export class LoginPageModule {
}
